module.exports = __webpack_public_path__ + "static/img/contact_img_QR01.82d0c0f.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/guanyu/contact_img_QR01.png
// module id = Hers
// module chunks = 1